import { render } from "./dform.vue?vue&type=template&id=cf87c6e0&ts=true"
import script from "./dform.vue?vue&type=script&lang=ts"
export * from "./dform.vue?vue&type=script&lang=ts"

import "./dform.vue?vue&type=style&index=0&id=cf87c6e0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__